var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDispatching(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.803 13.393-.524-.524c.225-.45.3-.9.3-1.348 0-.6-.3-1.2-.75-1.574a2.488 2.488 0 0 0-3.52 0 2.487 2.487 0 0 0 0 3.52c.824.825 1.947.975 2.92.45l.525.525c.15.15.375.225.525.225.15 0 .374-.075.524-.225.3-.3.3-.749 0-1.049zm-2.022-.974c-.375.375-1.05.375-1.424 0-.374-.374-.374-1.049 0-1.423.225-.15.45-.3.675-.3.3 0 .524.075.749.3.15.15.224.3.224.6.076.299-.074.598-.224.823zM6.91 1.333a3.445 3.445 0 1 1 .002 6.891 3.445 3.445 0 0 1-.001-6.89z",
    fill: "#E025FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.163 9.724c-1.049 0-2.023.15-2.772.374-.45.15-.899.375-1.199.675-.299.299-.524.749-.524 1.273 0 .525.15.9.524 1.274.3.299.75.524 1.2.673.748.226 1.722.375 2.771.375.45 0 .75-.3.75-.75v-3.145c0-.45-.3-.75-.75-.75z",
    fill: "#E025FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatching);
export default __webpack_public_path__ + "static/media/dispatching.cacca82e8a1ee4edccf0ebbf2b83bd22.svg";
export { ForwardRef as ReactComponent };